<template>
  <acknowledge :headline="headline">
    <template slot="image">
      <img class="baseball" alt="baseball" src="../../assets/images/20a-lrn-spt-cat-3-icon-def.svg"/>
    </template>
    <template slot="message">
      <p>Your pricing request has been sent!<br />
        Thank you for your interest in Lerner Sports!</p>
    </template>
  </acknowledge>
</template>

<script>
  import Acknowledge from '@/component/Acknowledge';

  export default {
    name: 'RequestPricingAcknowledge',

    components: {
      Acknowledge
    },

    data: function () {
      return {
        headline: 'And it\'s out of here!',
      }
    }
  };
</script>

<style lang="scss" scoped>
  img {
    max-width: 250px;
    @apply my-6;
  }

  button {
    @apply bg-lerner-blue text-white font-bold py-2 px-8 rounded-full;

    &:hover {
      background: lighten(#2d4c90, 10%);
    }
  }
</style>